/**
 * Class to represent a Stormpath Authentication Token.
 */
export var AuthToken = (function () {
    function AuthToken(accessToken, refreshToken, tokenType, expiresIn, expiresAt, exp) {
        this.accessToken = accessToken;
        this.refreshToken = refreshToken;
        this.tokenType = tokenType;
        this.expiresIn = expiresIn;
        this.expiresAt = expiresAt;
        this.exp = exp;
    }
    AuthToken.isValid = function (token) {
        return token && new Date() <= new Date(token.exp);
    };
    return AuthToken;
}());
//# sourceMappingURL=auth.token.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-stormpath/dist/esm/src/stormpath/auth.token.js
// module id = 349
// module chunks = 0